import React, {
  useEffect,
  useState,
} from 'react';
import Box from '@mui/material/Box';
import { statuses } from '../../schema/statuses';
import Grid from '@mui/material/Unstable_Grid2';
import StatusManagementItem from './StatusManagementItem';
import { Header } from './Header';

const StatusManagement = () => {
  const [visibleStatuses, setVisibleStatuses] = useState(statuses);

  useEffect(() => {
    document.title = `Zoe - Status Management`;
  }, []);

  return (
    <>
      <Header title={'Status Management'} />

      <Box
        sx={{
          padding: '15px',
          flexGrow: 1,
        }}
      >
        <Grid container spacing={'20px'}>
          {Object.keys(visibleStatuses).map((statusName) => {
            const statusSchema = visibleStatuses[statusName];
            if (!statusSchema?.show) {
              return <></>;
            }
            return <StatusManagementItem schema={statusSchema} />;
          })}
        </Grid>
      </Box>
    </>
  );
};
export default StatusManagement;
